function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useReducer, useEffect, useCallback, useMemo } from 'react';
import { fetchWithTokenAndRegion } from '@adsk/acs-sc-web-platform-api';
const FETCH_ACTIONS = {
  FETCH_INIT: 'FETCH_INIT',
  FETCH_SUCCESS: 'FETCH_SUCCESS',
  FETCH_FAILURE: 'FETCH_FAILURE',
  SET_DATA: 'SET_DATA'
};
const CONFIG_ACTIONS = {
  SET_CONFIG: 'SET_CONFIG',
  MANUAL_SET_CONFIG: 'MANUAL_SET_CONFIG',
  REFRESH: 'REFRESH'
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const dataFetchReducer = (state, action) => {
  switch (action.type) {
    case FETCH_ACTIONS.FETCH_INIT:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: true,
        error: null
      });
    case FETCH_ACTIONS.FETCH_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        error: null,
        data: action.payload
      });
    case FETCH_ACTIONS.FETCH_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        error: action.payload
      });
    case FETCH_ACTIONS.SET_DATA:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: action.payload
      });
    default:
      throw new Error();
  }
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const configReducer = (state, action) => {
  switch (action.type) {
    case CONFIG_ACTIONS.SET_CONFIG:
      return _objectSpread(_objectSpread({}, state), {}, {
        prevConfig: action.payload,
        config: action.payload
      });
    case CONFIG_ACTIONS.MANUAL_SET_CONFIG:
      return _objectSpread(_objectSpread({}, state), {}, {
        config: action.payload,
        requestId: state.requestId + 1
      });
    case CONFIG_ACTIONS.REFRESH:
      return _objectSpread(_objectSpread({}, state), {}, {
        requestId: state.requestId + 1
      });
    default:
      throw new Error();
  }
};

/**
 * useDataApi hook can be used to fetch data and get the request status easily. This hook adds `Authorization` and `Region` header using `fetchWithTokenAndRegion`.
 * A new request would be sent each time:
 *  - `url` or `fetchData` are changed
 *  - calling `refresh`
 *  - calling `doFetch`
 *
 * If you need request to initiate only upon manual interaction, pass an empty `url` and call `doFetch` with the needed request URL & data.
 * You can use `setData` to set the data manually.
 *
 * @param url - the URL to send request to.
 * @param fetchData - additional data for `window.fetch` if needed.
 *
 * @returns {{loading: boolean, data: null, error: null, refresh: *, doFetch: *, setData: *}}
 */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const useDataApi = (url, fetchData) => {
  const [fetchState, dispatchFetchAction] = useReducer(dataFetchReducer, {
    loading: false,
    error: null,
    data: null
  });
  const config = useMemo(() => ({
    url,
    fetchData
  }), [url, fetchData]);
  const [configState, dispatchConfigAction] = useReducer(configReducer, {
    config,
    prevConfig: config,
    requestId: 0
  });
  useEffect(() => {
    // Check if hook's args were changed. In that case we need to initiate a new request.
    dispatchConfigAction({
      type: CONFIG_ACTIONS.SET_CONFIG,
      payload: config
    });
  }, [config]);
  useEffect(() => {
    if (!configState.config.url) return;
    dispatchFetchAction({
      type: FETCH_ACTIONS.FETCH_INIT
    });
    let cancel = false;
    fetchWithTokenAndRegion(configState.config.url, configState.config.fetchData).then(response => {
      if (!cancel) {
        dispatchFetchAction({
          type: FETCH_ACTIONS.FETCH_SUCCESS,
          payload: response
        });
      }
    }).catch(error => {
      if (!cancel) {
        dispatchFetchAction({
          type: FETCH_ACTIONS.FETCH_FAILURE,
          payload: error
        });
      }
    });
    // eslint-disable-next-line consistent-return
    return () => {
      cancel = true;
    };
  }, [configState.config, configState.requestId]);
  const refresh = useCallback(() => dispatchConfigAction({
    type: CONFIG_ACTIONS.REFRESH
  }), []);
  const doFetch = useCallback((url, fetchData) => dispatchConfigAction({
    type: CONFIG_ACTIONS.MANUAL_SET_CONFIG,
    payload: {
      url,
      fetchData
    }
  }), []);
  const setData = useCallback(data => dispatchFetchAction({
    type: FETCH_ACTIONS.SET_DATA,
    payload: data
  }), []);
  return _objectSpread(_objectSpread({}, fetchState), {}, {
    refresh,
    setData,
    doFetch
  });
};
export default useDataApi;
//# sourceMappingURL=useDataApi.js.map